module.exports = __webpack_public_path__ + "static/media/48-iveco-mercedes.803e1ea4.jpg";